class NSSStickyCTA extends HTMLElement {
  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Sticky CTA] Connected.`);

    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    this.initObserver();

    window.matchMedia(`(max-width: 989px)`).addEventListener(`change`, () => {
      this.syncBodyClass();
    });
  }

  initObserver() {
    const heroEl = document.querySelector(`nss-hero-carousel`);

    if (!heroEl) {
      if (this.debug) console.warn(`[NSS][Sticky CTA] No nss-hero-carousel — staying hidden.`);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.boundingClientRect.bottom <= 0) {
            this.show();
          } else {
            this.hide();
          }
        });
      },
      { root: null, threshold: 0 }
    );

    observer.observe(heroEl);
  }

  show() {
    this.classList.add(`nss-open`);
    this.syncBodyClass();
  }

  hide() {
    this.classList.remove(`nss-open`);
    this.syncBodyClass();
  }

  // Shares nss-sticky-atc-visible with the buybox sticky ATC: the class is on
  // <body> while the buybox sticky ATC is on screen at any width. The CTA only
  // counts on mobile (< 990px), where it docks to the bottom edge.
  syncBodyClass() {
    const mobile = window.matchMedia(`(max-width: 989px)`).matches;
    const atcVisible = !!document.querySelector(`nss-buybox-sticky-atc-variant.nss-active.nss-open`);
    const ctaVisible = !!document.querySelector(`nss-sticky-cta.nss-open`);
    document.body.classList.toggle(`nss-sticky-atc-visible`, atcVisible || (mobile && ctaVisible));
    document.body.classList.toggle(`nss-sticky-cta-visible`, mobile && ctaVisible);
  }
}

let elementName = `nss-sticky-cta`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSStickyCTA);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
